import React from 'react'
import PetAdoptionJourney from './PetAdoptionJourney'
import { FaSearch, FaCalendarAlt, FaHeart } from 'react-icons/fa';

const steps = [
    {
      icon: <FaSearch className="text-orange-500 text-4xl" />,
      title: "Search",
      description: "Simply enter your city and start your search.",
    },
    {
      icon: <FaCalendarAlt className="text-orange-500 text-4xl" />,
      title: "Meet",
      description: "Schedule your appointment to meet the pet you love.",
    },
    {
      icon: <FaHeart className="text-orange-500 text-4xl" />,
      title: "Adopt",
      description: "Finally, adopt the dog or cat you love.",
    },
  ];
const Adoptapet = () => {
  return (
    <div>
      <div style={{ backgroundImage: 'url(./fdog.webp)', height: "800px",  width: "100%", backgroundRepeat: "no-repeat" }}>

      </div>
      <div className="bg-gray-50 py-16">
      <div className="max-w-6xl mx-auto px-6 text-center shadow-xl mt-[-150px] bg-white">
        <h2 className="text-4xl font-bold text-gray-800 mb-4 pt-6">
          Re-Home and Adopt a Pet in India
        </h2>

        <p className="text-lg text-gray-600 mb-6">
          Every Pet Deserves a Good Home.
        </p>

        <h3 className="text-2xl font-semibold text-orange-500">
          #Adoptlove
        </h3>

        <div className="mt-6 pb-6">
          <button className="bg-orange-500 text-white py-3 px-8 rounded-lg hover:bg-orange-600 transition-all duration-300">
            Adopt a Pet Now
          </button>
        </div>
      </div>
    </div>
    <PetAdoptionJourney/>
    <div className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl font-bold text-center text-gray-800 mb-8">
          How it Works?
        </h2>

        <div className="flex flex-col md:flex-row gap-12 items-center justify-center">
          {steps.map((step, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center p-6 bg-white shadow-lg rounded-lg hover:shadow-xl transition-all duration-300 w-full md:w-1/3"
            >
              <div className="mb-4">{step.icon}</div>
              <h3 className="text-2xl font-semibold text-gray-800 mb-2">{step.title}</h3>
              <p className="text-gray-600">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
    
    </div>
  )
}

export default Adoptapet
